import {BaseService} from "./BaseService.ts";
import {CreateAttribute} from "../model/request/attribute/CreateAttribute.ts";
import {DeleteAttribute} from "../model/request/attribute/DeleteAttribute.ts";
import {UpdateAttribute} from "../model/request/attribute/UpdateAttribute.ts";
import {CreateBulkAttributeRequest} from "../model/request/attribute/CreateBulkAttributeRequest.ts";
import {ReadAttributeByEntityId} from "../model/request/attribute/ReadAttributeByEntityId.ts";

export class AttributeService {
    static create = (others: any, data: CreateAttribute) => {
        return BaseService.apiClient(others).post("attribute/create", data);
    }
    static readAttributeById = (others: any, data: ReadAttributeByEntityId) => {
        return BaseService.apiClient(others).get(`attribute/read-by-attribute-entity-id/${data.attributeEntityId}`);
    }
    static bulkCreate = (others: any, data: CreateBulkAttributeRequest) => {
        return BaseService.apiClient(others).post("bulk-attribute/bulk-create", data);
    }
    static delete = (others: any, data: DeleteAttribute) => {
        return BaseService.apiClient(others).post("attribute/delete", data);
    }
    static update = (others: any, data: UpdateAttribute) => {
        return BaseService.apiClient(others).post("attribute/update", data);
    }
    static readAttribute = (others: any) => {
        return BaseService.apiClient(others).get("attribute/read");
    }

}